/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_Search_NameInputs */

const en_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior React roles`)
};

const de_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Senior React Stellen`)
};

const fr_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Postes Senior React`)
};

const es_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Puestos Senior React`)
};

const it_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Ruoli React senior`)
};

const nl_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Senior React-rollen`)
};

const pl_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Stanowiska Senior React`)
};

const fi_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. Senior React -tehtävät`)
};

const da_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. Senior React-roller`)
};

const sv_jobs_placeholder_search_name = /** @type {(inputs: Jobs_Placeholder_Search_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. Senior React-roller`)
};

/**
* | output |
* | --- |
* | "e.g. Senior React roles" |
*
* @param {Jobs_Placeholder_Search_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_search_name = /** @type {((inputs?: Jobs_Placeholder_Search_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_Search_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_search_name(inputs)
	if (locale === "fr") return fr_jobs_placeholder_search_name(inputs)
	if (locale === "es") return es_jobs_placeholder_search_name(inputs)
	if (locale === "it") return it_jobs_placeholder_search_name(inputs)
	if (locale === "nl") return nl_jobs_placeholder_search_name(inputs)
	if (locale === "pl") return pl_jobs_placeholder_search_name(inputs)
	if (locale === "fi") return fi_jobs_placeholder_search_name(inputs)
	if (locale === "da") return da_jobs_placeholder_search_name(inputs)
	if (locale === "sv") return sv_jobs_placeholder_search_name(inputs)
	return en_jobs_placeholder_search_name(inputs)
});